import React, { useState } from 'react'
import styled from 'styled-components'
import RGL, { WidthProvider } from 'react-grid-layout'
const ReactGridLayout = WidthProvider(RGL)

import { useHistory, useParams } from 'react-router-dom'
import IncidentWindow from './IncidentWindow'
import Tabs from './Tabs'

const Wrapper = styled.div`
  .react-grid-item {
    background-color: ${({ theme }) => theme.colors.white};
  }
  padding-left: 90px;
`

const Window = styled.div`
  display: grid;
  padding: 40px 20px 20px 0;
  border-radius: 3px;
`
//dummy data
const data = {
  personalData: {
    fullName: 'John Wick',
    statistics: {
      count: 5,
    },
    time: 20,
    finishTime: 30,
    assign: [
      { value: 'green', label: 'Green' },
      { value: 'blue', label: 'Blue' },
      { value: 'red', label: 'Red' },
      { value: 'yellow', label: 'Yellow' },
    ],
    severity: [
      { value: 'gray', label: 'Gray' },
      { value: 'blue', label: 'Blue' },
      { value: 'red', label: 'Red' },
      { value: 'yellow', label: 'Yellow' },
    ],
  },
  timeDetails: {
    fullName: 'John Wick',
    statistics: {
      count: 5,
    },
    time: 20,
    finishTime: 30,
  },
  caseInfo: {
    fullName: 'John Wick',
    statistics: {
      count: 10,
    },
    time: 20,
    finishTime: 30,
    titleDropdown: [
      { value: 'black', label: 'Black' },
      { value: 'blue', label: 'Blue' },
      { value: 'red', label: 'Red' },
      { value: 'yellow', label: 'Yellow' },
    ],
  },
  incidentStats: {
    fullName: 'John Wick',
    statistics: {
      count: 5,
    },
    time: 20,
    finishTime: 30,
  },
}
//dummy meta data
const metaDataInitial = {
  tabs: [
    //////////////// Tab one
    {
      tabTitle: 'Main',
      windows: [
        // Window one
        {
          title: 'Personal data',
          accessor: 'personalData',
          fields: [
            {
              label: 'Name',
              accessor: 'fullName',
            },
            {
              label: 'Count',
              accessor: 'statistics.count',
            },
            {
              label: 'Assign',
              accessor: 'assign',
              type: 'dropdown',
            },
            {
              label: 'Severity',
              accessor: 'severity',
              type: 'dropdown',
            },
          ],
        },
        // Window two
        {
          title: 'Time details',
          accessor: 'timeDetails',
          fields: [
            {
              label: 'Begin time',
              accessor: 'time',
            },
            {
              label: 'End time',
              accessor: 'finishTime',
            },
          ],
        },
        {
          title: 'Time details',
          accessor: 'timeDetails',
          fields: [
            {
              label: 'Begin time',
              accessor: 'time',
            },
            {
              label: 'End time',
              accessor: 'finishTime',
            },
          ],
        },
        {
          title: 'Time details',
          accessor: 'timeDetails',
          fields: [
            {
              label: 'Begin time',
              accessor: 'time',
            },
            {
              label: 'End time',
              accessor: 'finishTime',
            },
          ],
        },
        {
          title: 'Time details',
          accessor: 'timeDetails',
          fields: [
            {
              label: 'Begin time',
              accessor: 'time',
            },
            {
              label: 'End time',
              accessor: 'finishTime',
            },
          ],
        },
        {
          title: 'Time details',
          accessor: 'timeDetails',
          fields: [
            {
              label: 'Begin time',
              accessor: 'time',
            },
            {
              label: 'End time',
              accessor: 'finishTime',
            },
          ],
        },
      ],
    },
    //////////////Tab Second
    {
      tabTitle: 'Second',
      windows: [
        // Window one
        {
          title: 'Case info',
          accessor: 'caseInfo',
          fields: [
            {
              label: 'Name',
              accessor: 'fullName',
            },
            {
              label: 'Count',
              accessor: 'statistics.count',
            },
            {
              label: 'Title',
              accessor: 'titleDropdown',
              type: 'dropdown',
            },
          ],
        },
        // Window two
        {
          title: 'Incidents Stats',
          accessor: 'incidentStats',
          fields: [
            {
              label: 'Some time',
              accessor: 'time',
            },
            {
              label: 'Some time',
              accessor: 'time',
            },
            {
              label: 'Some time',
              accessor: 'time',
            },
            {
              label: 'End time',
              accessor: 'finishTime',
            },
          ],
        },
      ],
    },
  ],
}

const IncidentDetail: React.FC = () => {
  const { id, tab } = useParams<{ id: string; tab: string }>()

  const [metadata] = useState<any>(metaDataInitial)
  const [active, setActive] = useState(tab)
  const history = useHistory()

  //TODO positions also could be in external data
  const layout = {
    0: { i: '0', x: 0, y: 0, w: 1, h: 9, maxW: 1 },
    1: { i: '1', x: 1, y: 0, w: 1, h: 9, maxW: 1 },
    2: { i: '2', x: 2, y: 0, w: 1, h: 9, maxW: 1 },
    3: { i: '3', x: 0, y: 9, w: 1, h: 9, maxW: 1 },
    4: { i: '4', x: 1, y: 9, w: 2, h: 9, maxW: 2 },
    5: { i: '5', x: 0, y: 18, w: 3, h: 9, maxW: 3 },
  }

  const tabs = metadata.tabs.map((tab) => {
    return <div key={tab.tabTitle.toLowerCase()}>{tab.tabTitle}</div>
  })

  const handleChangeTab = (active) => {
    setActive(active)
    history.replace(`/incidents/${id}/${active}`)
  }

  const tabContent = metadata.tabs.reduce((accumulator, tab) => {
    const key = tab.tabTitle.toLowerCase()
    const windows = (
      <ReactGridLayout
        isDraggable={false}
        className="layout"
        cols={3}
        rowHeight={30}
      >
        {tab.windows.map((window, key) => {
          return (
            <Window
              key={key}
              data-grid={{
                i: layout[key].i,
                x: layout[key].x,
                y: layout[key].y,
                w: layout[key].w,
                h: layout[key].h,
                maxW: layout[key].maxW,
              }}
            >
              <IncidentWindow {...window} data={data[window.accessor]} />
            </Window>
          )
        })}
      </ReactGridLayout>
    )

    //return object {tabName: windows ,tab2Name: windows, ...}
    return {
      ...accumulator,
      [key]: windows,
    }
  }, {})

  return (
    <Wrapper>
      <div>
        <Tabs active={active} onChange={handleChangeTab}>
          {tabs}
        </Tabs>
        <div>{tabContent[active]}</div>
      </div>
      <span>Incident ID: {id}</span>
    </Wrapper>
  )
}

export default IncidentDetail
